module.exports = __webpack_public_path__ + "media/images/stories/256_rsz_rhema-kallianpur-275251-unsplash-108c52753920b6c2a7058c8833cc5534.jpg";